var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('diagram-element',{ref:"reportStatistics",attrs:{"showadd":true,"allownesting":true,"showcontrols":true},on:{"change":_vm.statisticsChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75aca524","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statistics/statistics-editor.vue
// module id = 1904
// module chunks = 0